module.exports = __webpack_public_path__ + "img/components (1).3347e582.png";